// extracted by mini-css-extract-plugin
module.exports = {"switcher":"switcher_switcher__ljV__","item":"switcher_item__SoW1u"};